const contentArea = {
  bindings: {
    selection: '<',
    progressList: '<',
    currentlyUpdatingProgressList: '<',
    activationProgressList: '<',
    train: '<',
    carNumber: '<',
    descriptors: '<',
    availablePackages: '<',
    onUpload: '&',
  },
  templateUrl: '/modules/configurationManagement/train-management/content-area/content-area.html',
  controller: 'ContentAreaController',
};

angular
  .module('configuration-management.module')
  .component('contentArea', contentArea);